module.exports = __webpack_public_path__ + "img/welcome-to-barianERP.7cc200f3.png";